<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "DAT_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-outline-success"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                        [id]    ="DAT_AG_GRID.id" 
                        [class] ="DAT_AG_GRID.class" 
                        [ngStyle]="DAT_AG_GRID.style" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        [pagination]="DAT_AG_GRID.pagination" 
                        [paginationPageSize]="DAT_AG_GRID.pagina"
                        [allowContextMenuWithControlKey]="true"
                        [frameworkComponents]="frameworkComponents" >
      </ag-grid-angular>
    </ng-template>
    <!-- GRILLA -->
  </div>
  
  <!-- MODAL -->
  <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-lg'" [idButton] = "'abrirModal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
  </app-lfsa-modal>
  
  <ng-template #abrirModal>
    <div class="container-fluid">
      <form [formGroup]="formulario" mat-dialog-content>
        <div class="row">            
          <div class="col">
            <app-lfsa-combo-box [label]="'* Seleccione Localidad'" formControlName="localidad" [control]="formulario.get('localidad')" 
                                [comboBox]="cbxLocalidad" [opcion]="'dscaLocalidad'" [idOpcion]="'localidad'" [habilitar]="!isCreate">
            </app-lfsa-combo-box>
          </div>
  
          <div class="col">
            <app-lfsa-combo-box [label]="'* Seleccione Tipo Alimento'" formControlName="tipoComida" [control]="formulario.get('tipoComida')" 
                                [comboBox]="cbxComida" [opcion]="'valor'" [idOpcion]="'clave'" [habilitar]="!isCreate">
            </app-lfsa-combo-box>
          </div>

          <div class="col">
            <app-lfsa-combo-box [label]="'* Seleccione Tipo Empleado'" formControlName="tipoEmpleado" [control]="formulario.get('tipoEmpleado')" 
                                [comboBox]="cbxTipoEmpleado" [opcion]="'valor'" [idOpcion]="'clave'" [habilitar]="!isCreate">
            </app-lfsa-combo-box>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <app-lfsa-input formControlName="precio" [label]="'* Ingrese Precio'" [id]="'precio'" [control]="formulario.get('precio')" [type]="'number'" >
            </app-lfsa-input>
          </div>

          <div class="col">
            <app-lfsa-input formControlName="valorFabril" [label]="'* Valor % Subsidio'" [id]="'valorFabril'" [control]="formulario.get('valorFabril')" [type]="'number'" >
            </app-lfsa-input>
          </div>

          <div class="col">
            <app-lfsa-input formControlName="valorCopago" [label]="'* Valor % Colaborador'" [id]="'valorCopago'" [control]="formulario.get('valorCopago')" [type]="'number'" >
            </app-lfsa-input>
          </div>

          <div class="col">
            <app-lfsa-input formControlName="totalValor" [label]="'* TOTAL'" [id]="'totalValor'" [control]="formulario.get('totalValor')" [type]="'number'" [isReadOnly]="true">
            </app-lfsa-input>
            <small *ngIf="formulario.hasError('sumNotEqual')" class="letrasDanger">La suma de los dos valores debe ser igual a 100.</small>
          </div>
        </div>

        <app-lfsa-botones-formulario 
            (devolverAccion) ="acciones( $event )" 
            [formularioValido] ="formulario.invalid" 
            [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
        </app-lfsa-botones-formulario>

      </form>

    </div>
  </ng-template>
  <!-- END MODAL --> 
